import React, { Component } from 'react';
import {
  Button,
  SplitButton,
  MenuItem,
} from 'react-bootstrap';
import { generate } from 'shortid';
// icons
import Icon from 'react-icons/lib/go/plus';
// stores
import PropertyStore from '../../stores/PropertyStore';
import PasscodeStore from '../../stores/PasscodeStore';
import UserStore from '../../stores/UserStore';
// models
import Property from '../../models/Property';
import Passcode from '../../models/Passcode';
// components
import PropertyDialog from '../../components/Property/PropertyDialog';
// css
import './Buttons.css';

class AddPropertyButton extends Component {
  constructor(props) {
    super(props);
    this.state = { showDialog: false };
  }

  render() {
    const {
      trigger,
      disabled = false,
    } = this.props;
    const properties = PropertyStore.properties;
    const count = properties.length;

    if (trigger) {
      return (
        <div onClick={() => { disabled || this.showDialog(true); }}>
          {trigger}
          {this.renderPropertyDialog()}
        </div>
      );
    }

    if (!count || count === 1) {
      return (
        <Button
          bsStyle="success"
          className="buttons-container"
          disabled={disabled}
          onClick={() => this.showDialog(true)}>
          {this.renderTitle()}
          {this.renderPropertyDialog()}
        </Button>
      );
    }

    return (
      <SplitButton
        id={generate()}
        bsStyle="success"
        title={this.renderTitle()}
        className="Buttons-container"
        disabled={disabled}
        onSelect={this.onSelect}
        onClick={() => this.showDialog(true)}>
        <MenuItem header>My properties</MenuItem>
        <MenuItem divider />
        {
          properties.map((prop, i) => {
            return <MenuItem key={prop.id} eventKey={prop.id}>{prop.name}</MenuItem>;
          })
        }
        {this.renderPropertyDialog()}
      </SplitButton>
    );
  }

  renderPropertyDialog = () => {
    return (
      <PropertyDialog
        show={this.state.showDialog}
        property={new Property()}
        onSave={this.onSave}
        onCancel={() => this.showDialog(false)} />
    );
  }

  renderTitle = () => {
    return (
      <div>
        <div className="Buttons-icon"><Icon /></div>
        <div className="Buttons-text">Property</div>
      </div>
    );
  }

  showDialog = (bShow = true) => {
    if (bShow && !UserStore.user.hasPaymentMethod()) {
      alert("Please add a payment method first");
      return;
    }
    this.setState({ showDialog: bShow });
  }

  onSelect = (eventKey, e) => {
    e && e.preventDefault && e.preventDefault();
    const property = PropertyStore.setSelectedProperty(eventKey);
    PasscodeStore.setProperty(property);
  }

  onSave = (property) => {
    if (property) {
      PropertyStore
      .add(property)
      .then(PasscodeStore.setProperty)
      .then(() => PasscodeStore.add(new Passcode()));

      this.showDialog(false);
    }
  }
}

export default AddPropertyButton;


// WEBPACK FOOTER //
// ./src/components/Buttons/AddProperty.js